import { IDictionary, isNullOrUndefined } from '@bimser/core';
import dayjs from 'dayjs';
import DataGrid from '..';

export function getExtremeGridRows(this: DataGrid, row: any, index?: number) {
	const newRow: IDictionary<any> = {};
	row.cells?.forEach(cell => {
		switch (cell.editType) {
			case 'comboBox': {
				newRow[cell.name] = selectColumnCellValue.call(this, cell);
				break;
			}
			case 'numberBox': {
				newRow[cell.name] = numberColumnCellValue.call(this, cell);
				break;
			}
			case 'datePicker': {
				newRow[cell.name] =
					!isNullOrUndefined(cell.value) && dayjs(cell.value).isValid()
						? dayjs(cell.value).format('YYYY-MM-DD')
						: null;
				break;
			}
			case 'timePicker': {
				newRow[cell.name] = timeColumnCellValue.call(this, cell);
				break;
			}
			case 'textBox': {
				newRow[cell.name] =
					!isNullOrUndefined(cell.text) && typeof cell.text === 'object'
						? JSON.stringify(cell.text)
						: cell.text;
				break;
			}
			default: {
				newRow[cell.name] = cell.value;
				break;
			}
		}
	});

	if (row.data) {
		Object.keys(row.data).forEach(key => {
			if (isNullOrUndefined(newRow[key])) {
				newRow[key] = row.data[key];
			}
		});
	}

	if (row.cellData) {
		Object.keys(row.cellData).forEach(key => {
			if (isNullOrUndefined(newRow[key])) {
				newRow[key] = row.cellData[key];
			}
		});
	}

	newRow['index'] = row.index;

	return newRow;
}

function timeColumnCellValue(this: DataGrid, cell: any) {
	let value = null;
	if (!isNullOrUndefined(cell.value)) {
		value = (typeof cell.value as 'string') ? cell.value : dayjs(cell.value);
	}
	return value;
}

function selectColumnCellValue(this: DataGrid, cell: any) {
	let item = cell.value;
	const column = this.columns.find(col => col.name == cell.name);
	if (!isNullOrUndefined(cell.value) && column.dbType.type == 'object') {
		const control = column.editControl as any;
		const value = control.dataSourceType === 'static' ? cell.value?.toString() : cell.value;
		item = { key: cell.value.toString(), value: value, text: cell.text };
	} else if (column.dbType.type == 'decimal') {
		const reg = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;
		return !isNullOrUndefined(cell.value) &&
			!isNaN(cell.value) &&
			reg.test(cell.value) &&
			cell.value !== ''
			? Number(cell.value)
			: null;
	}
	return item;
}

function numberColumnCellValue(this: DataGrid, cell: any) {
	const reg = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;
	return !isNullOrUndefined(cell.value) &&
		!isNaN(cell.value) &&
		reg.test(cell.value) &&
		cell.value !== ''
		? Number(cell.value)
		: null;
}
